export const environment = {
  production: false,
  cenplexBookingApiBaseUrl: 'https://api.int.cenplexbooking.ch/v1',
  // cenplexBookingApiBaseUrl: 'http://localhost:5134/v1',
  // cenplexBookingApiBaseUrl: 'https://dev-cenplex-booking-svc-aca.salmonfield-07c50e2a.switzerlandnorth.azurecontainerapps.io/v1',
  clientId: 'dev-frontend',
  privacyPolicyUrl: 'https://cenplex.ch/datenschutz'
};
